import React from 'react';
import { useAutoTextFit } from '../hooks/useAutoTextFit';

interface AutoFitTextProps {
  children: React.ReactNode;
  maxHeight?: string; // ej: "100vh"
  padding?: number; // padding vertical total (top + bottom)
  minFontSize?: number; // tamaño mínimo permitido (ej: 12px)
  maxFontSize?: number; // tamaño máximo permitido (ej: 80px)
  initialFontSize?: number; // DEPRECATED: Se mantiene por compatibilidad pero el hook calcula el inicial
  lineHeight?: number; // factor de line-height (ej: 1.4)
  className?: string;
}

/**
 * Componente que ajusta automáticamente el tamaño del texto
 * para que quepa en el espacio disponible sin scroll.
 * Utiliza el hook useAutoTextFit para la lógica de cálculo.
 */
const AutoFitText: React.FC<AutoFitTextProps> = ({
  children,
  maxHeight = '100vh',
  padding = 48,
  minFontSize = 12,
  maxFontSize = 80,
  lineHeight = 1.4,
  className = '',
}) => {
  const { ref, fontSize, isAdjusting } = useAutoTextFit(children, {
    minFontSize,
    maxFontSize,
    lineHeight,
    padding,
  });

  return (
    <div
      ref={ref}
      className={className}
      style={{
        fontSize: `${fontSize}px`,
        lineHeight: lineHeight,
        width: '100%',
        height: maxHeight === '100%' ? '100%' : maxHeight,
        maxHeight: maxHeight,
        minHeight: maxHeight === '100%' ? '100%' : maxHeight, // Forzar que use todo el espacio disponible
        display: 'flex',
        alignItems: 'flex-start', // Cambiar de 'center' a 'flex-start' para que empiece desde arriba
        justifyContent: 'center',
        overflow: 'hidden', // Importante: ocultar overflow mientras se ajusta
        opacity: isAdjusting ? 0 : 1, // Opcional: ocultar parpadeo inicial
        transition: 'opacity 0.1s ease-in',
        position: 'relative',
      }}
    >
      <div
        id="auto-fit-content-wrapper"
        style={{
          width: '100%',
          display: 'block',
          position: 'relative',
          paddingBottom: '1px', // Evitar margin collapse para medición precisa
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AutoFitText;

